import React from "react";
import { formatBreakTime } from "./timecardBreakUtils";

// Lists each recorded break as "start - end", matching the clock in/out column.
// `paid` limits the list to paid (true) or unpaid (false) breaks; omit for all.
// `timeZone` is optional; omit it to use the viewer's browser time.
export default function BreakDetails({ entry, paid, timeZone }) {
  const breaks = (entry.recorded_breaks ?? entry.timecard_breaks ?? []).filter(
    (brk) => paid === undefined || Boolean(brk.is_paid) === paid
  );
  return (
    <>
      {breaks.map((brk, index) => (
        <div key={brk.uuid || index} className="text-xs text-slate-500">
          {formatBreakTime(brk.clocked_in_at, timeZone)} - {formatBreakTime(brk.clocked_out_at, timeZone)}
        </div>
      ))}
    </>
  );
}
